export class EmailRendererClient {
    public browser: string;
    public category: string;
    public client: string;
    public id: string;
    public os: string;

    constructor(emailRendererClient?: EmailRendererClient) {
        this.browser = emailRendererClient && emailRendererClient.browser || null;
        this.category = emailRendererClient && emailRendererClient.category || null;
        this.client = emailRendererClient && emailRendererClient.client || null;
        this.id = emailRendererClient && emailRendererClient.id || null;
        this.os = emailRendererClient && emailRendererClient.os || null;
    }
}
